/**
 * Tab / device / customer persistence keys — shared by services and TrackingClient teardown.
 */
export const StorageKey = {
  TabId: 'bv_tab_id',
  TabLastActive: 'bv_tab_last_active',
  HeartbeatIndex: 'bv_heartbeat_index',
  LastProductId: 'bv_last_product_id',
  DeviceId: 'bv_device_id',
  CustomerId: 'bv_customer_id',
} as const;
